import { http } from '@/services/api/client';
import type { MeProfile } from '@/types/user';

export async function fetchMe(): Promise<MeProfile> {
  return http.get('/me') as Promise<MeProfile>;
}
